window.initGMapsComponents = function() {

  // init automplete address input
  window.addressAutocomplete = new google.maps.places.Autocomplete(
    (document.getElementById('autocomplete-gmaps-place')),
    {types: ['geocode']});
}